<nz-card>
    <form nz-form [formGroup]="conditionForm">
        <nz-form-item class="mb-sm">
            <nz-form-label [nzSpan]="6" nzFor="vendorcode">{{ 'ExpertRoleName' | translate }}</nz-form-label>
            <nz-form-control [nzSpan]="5">
                <input type="text" nz-input formControlName="roleName" nz-input />
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-label [nzSpan]="6" nzFor="vendorcode">{{ 'Emplid' | translate }}</nz-form-label>
            <nz-form-control [nzSpan]="5">
                <nz-select [nzServerSearch]="true" formControlName="userId" (nzOnSearch)="userSearch1($event)"
                    style="border-radius:6px;" nzPlaceHolder="{{'inputvalue'|translate}}" [nzAllowClear]="true"
                    [nzShowSearch]="true">
                    <nz-option *ngFor="let o of userOptionList" [nzValue]="o.userId" [nzLabel]="o.displayLabel"
                        nzCustomContent>
                        <span>{{o.displayLabel}}</span>
                    </nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item class="mb-sm">
            <nz-form-label [nzSpan]="6" nzFor="stat">{{ 'Status' | translate }}</nz-form-label>
            <nz-form-control [nzSpan]="5">
                <nz-select formControlName="useful" nzAllowClear>
                    <nz-option *ngFor="let item of statList" [nzValue]="item" [nzLabel]="item"></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>

        <nz-form-item>
            <nz-form-control [nzSm]="{ span: 2, offset: 7 }">
                <div class="button-group">
                    <!-- 按钮1：Search -->
                    <div nz-col [nzSpan]="12">
                        <button nz-button nzType="primary" class="default-button" (click)="onSearch()">
                            {{ 'Search' | translate }}
                        </button>
                    </div>
                    <!-- 按钮2：Add -->
                    <div nz-col [nzSpan]="12">
                        <button nz-button nzType="default" class="default-button" (click)="AddMROExpertItem()">
                            <i nz-icon nzType="plus"></i>
                            <span>{{ 'Add' | translate }}</span>
                        </button>
                    </div>
                </div>
            </nz-form-control>
        </nz-form-item>

        <!-- <nz-form-item>

        </nz-form-item> -->
    </form>
</nz-card>

<nz-card nzTitle="{{'Results' | translate}}({{total}})">
    <nz-table #colSpanTable [nzData]="listOfData" style="margin-bottom: 10px" nzSize="middle" nzShowSizeChanger
        [nzFrontPagination]="false" [nzShowPagination]='false' [nzPageSize]='pageSize' [nzPageIndex]='pageIndex'
        (nzCurrentPageDataChange)="onCurrentPageDataChange($event)" [nzScroll]="{ y: '800px',x:'200px' }">
        <thead>
            <tr>
                <th scope="col" style="text-align:center;" [nzSortFn]="true" nzWidth="5px"
                    (nzSortOrderChange)="sortChange({ key: 'roleChineseName', value: $event })">{{ "ExpertDomain" |
                    translate }}
                </th>
                <th scope="col" style="text-align:center;" [nzSortFn]="true" nzWidth="5px"
                    (nzSortOrderChange)="sortChange({ key: 'roleEnglishName', value: $event })">{{ "ExpertDomainEN" |
                    translate}}
                </th>
                <th scope="col" style="text-align:center;" [nzSortFn]="true" nzWidth="5px"
                    (nzSortOrderChange)="sortChange({ key: 'userId', value: $event })">{{ "ExpertUserId" |
                    translate}}
                </th>
                <th scope="col" style="text-align:center;" [nzSortFn]="true" nzWidth="5px"
                    (nzSortOrderChange)="sortChange({ key: 'UserName', value: $event })">{{ "ExpertUserName" |
                    translate}}
                </th>
                <th scope="col" style="text-align:center;" [nzRight]="true" nzWidth="5px">{{ "Edit" | translate}}</th>
                <th scope="col" style="text-align:center;" [nzRight]="true" nzWidth="5px">{{ "Delete" | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of colSpanTable.data;let i=index">
                <td style="text-align:center;">{{data.roleChineseName}}</td>
                <td style="text-align:center;">{{data.roleEnglishName}}</td>
                <td style="text-align:center;">{{data.userId}}</td>
                <td style="text-align:center;">{{data.userName}}</td>
                <td style="text-align:center;" class="fixed-column" [nzRight]="true">
                    <span nz-icon nzType="edit" nzTheme="twotone" style="font-size: 20px; cursor: pointer;" nz-tooltip
                        (click)="onEdit(data)"></span>
                </td>
                <td style="text-align:center;" class="fixed-column" [nzRight]="true">
                    <span nz-icon nzType="delete" nzTheme="twotone" style="font-size: 20px; cursor: pointer;" nz-tooltip
                        (click)="onDelete(data)"></span>
                </td>
            </tr>
        </tbody>
    </nz-table>
</nz-card>

<nz-modal [nzTitle]="'Edit'" [nzVisible]="isEditModalVisible" [nzContent]="modalContent" (nzOnOk)="onSure($event)"
    (nzOnCancel)="onCancel()" [nzMaskClosable]="false">
    <ng-template #modalContent>
        <form nz-form [formGroup]="editValidateForm">
            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6" nzRequired>{{ "RoleChineseName" | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="10">
                    <input nz-input formControlName="roleChineseName">
                </nz-form-control>
            </nz-form-item>
            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6" nzRequired>{{ "RoleEnglishName" | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="10">
                    <input nz-input formControlName="roleEnglishName">
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label [nzSpan]="6" nzFor="userId">{{ 'UserId' | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="10">
                    <nz-select [nzServerSearch]="true" formControlName="userId"
                        (nzOnSearch)="userSearch($event, 'edit')" style="border-radius:6px;"
                        nzPlaceHolder="{{'inputvalue'|translate}}" [nzAllowClear]="true" [nzShowSearch]="true">
                        <nz-option *ngFor="let o of editOptionList" [nzValue]="o" [nzLabel]="o.displayLabel"
                            nzCustomContent>
                            <span>{{o.displayLabel}}</span>
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

        </form>
    </ng-template>
</nz-modal>

<nz-modal [nzTitle]="'Add'" [nzVisible]="isAddModalVisible" [nzContent]="addModalContent" (nzOnOk)="onAddSure($event)"
    (nzOnCancel)="onAddCancel()" [nzMaskClosable]="false">
    <ng-template #addModalContent>
        <form nz-form [formGroup]="addValidateForm">
            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6" nzRequired>{{ "RoleChineseName" | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="10">
                    <input nz-input formControlName="roleChineseName">
                </nz-form-control>
            </nz-form-item>
            <nz-form-item class="mb-sm">
                <nz-form-label [nzSpan]="6" nzRequired>{{ "RoleEnglishName" | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="10">
                    <input nz-input formControlName="roleEnglishName">
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label [nzSpan]="6" nzFor="userId">{{ 'UserId' | translate }}</nz-form-label>
                <nz-form-control [nzSpan]="10">
                    <nz-select [nzServerSearch]="true" formControlName="userId" (nzOnSearch)="userSearch($event, 'add')"
                        style="border-radius:6px;" nzPlaceHolder="{{'inputvalue'|translate}}" [nzAllowClear]="true"
                        [nzShowSearch]="true">
                        <nz-option *ngFor="let o of addOptionList" [nzValue]="o" [nzLabel]="o.displayLabel"
                            nzCustomContent>
                            <span>{{o.displayLabel}}</span>
                        </nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

        </form>
    </ng-template>
</nz-modal>
